import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { MockEditService } from '../../../mock';
import { FormlyButtonDropdown, SummaryButton, SummaryItem } from '../../../models';
import { BaseEditCreateService, BaseEditService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-tab-form-modal',
  templateUrl: './tab-form-modal.component.html',
  styleUrl: './tab-form-modal.component.scss',
  imports: [SummaryTopComponent, NgTemplateOutlet],
})
export class TabFormModalComponent {
  protected saveClicked$ = new Subject<void>();

  public readonly header = input<string>();
  readonly model$ = input<Observable<any>>();
  public readonly showCopy = input(false);
  public readonly showSave = input(true);
  public readonly showBack = input(true);
  public readonly summaryItems = input<(model: any) => SummaryItem[]>();
  public readonly baseService = input<BaseEditService<any, any> | BaseEditCreateService<any, any>>(
    new MockEditService(),
  );
  public readonly isModal = input(true);
  public readonly copyButtonText = input($localize`Copy`);
  public readonly enableCopyButton = input(true);
  public readonly additionalButtons = input<SummaryButton[] | FormlyButtonDropdown[]>();
  public readonly createDropdown = input<FormlyButtonDropdown>();
  public readonly copyModel = output<void>();
  public readonly saveClicked = outputFromObservable<void>(this.saveClicked$);
}
